<template>
    <v-autocomplete
        :items="data"
        :loading="loading"
        item-text="name"
        item-value="id"
        @focus="fetchData"
        v-bind="$props"
        :value="value"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        >
    </v-autocomplete>
</template>

<script>
import { getMalfactions } from './../services/malfactions';

export default {
    name: "MalfactionsAutocomplete",
    props: {
        label: String,
        dense: Boolean,
        outlined: Boolean,
        backgroundColor: String,
        hideDetails: [String, Boolean],
        value: [String, Number]
    },
    data() {
        return {
            loading: false,
            data: []
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let r = await getMalfactions();
            this.data = r.data;
            this.loading = false;
        }
    },
    created() {
        this.fetchData();
    }
}
</script>

<style>

</style>